<template>
  <div class="popUpWrap" :class="{ black: dialogProps.popupClass === 'dark' }">
    <section class="popup" :class="popupClass" :style="dialogProps.popupStyle">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div v-if="dialogProps.icon" :class="['icon', dialogProps.icon]"></div>
        <div class="textArea flex">
          <h5>{{ dialogProps.title }}</h5>
          <p v-if="dialogProps.contents" v-html="contentsHtml" />
        </div>
        <div class="btnArea">
          <button ref="confirmButtonRef" @click.stop="onClickConfirm">{{ confirmTitle }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from '#imports';
import { convertToNextLine } from '~~/application/utils/StringUtil';
import { useDialogStore } from '~/store/dialog/dialogStore';
import { useI18n } from 'vue-i18n';
import type { GenericDialogProps } from '~/components/Common/Dialog/model/GenericDialogProps';

const { t } = useI18n();
const dialogStore = useDialogStore();
const confirmButtonRef = ref<HTMLButtonElement | null>(null);

const dialogProps = computed(() => dialogStore.options.props as GenericDialogProps);

// BR-1751 / BR-1745: contents 는 v-html 로 그려지므로 로케일의 `\n` 이 그대로면 공백으로 접혀
// 한 문단이 된다. 문장 단위 줄바꿈을 의도해 `\n` 을 넣은 문구(점검 안내·모바일 차단 등)가
// 화면에서만 한 덩어리로 보이던 원인이다. 호출부마다 변환을 흩뿌리면 또 빠지므로 여기서 한 번 한다.
const contentsHtml = computed(() => convertToNextLine(dialogProps.value.contents ?? ''));
const popupClass = computed(() => {
    const cls = dialogProps.value.popupClass ?? 'dark basic';
    return cls === 'dark' ? 'dark basic' : cls;
});
const confirmTitle = computed(() => dialogStore.options.confirm?.title ?? t('common-ok'));

// blur를 먼저 하는 이유: 확인 버튼 focus()가 어떤 이유로 실패하더라도 뒤쪽 화면이
// 포커스를 잃는 것만은 보장돼야 한다. 그쪽이 이 플래그의 안전상 핵심이다.
onMounted(() => {
    if (!dialogProps.value.autofocusConfirm) return;
    (document.activeElement as HTMLElement | null)?.blur();
    confirmButtonRef.value?.focus();
});

const onClickClose = () => {
    dialogStore.close();
    dialogStore.options.close?.event();
};

const onClickConfirm = () => {
    dialogStore.close();
    dialogStore.options.confirm?.event();
};
</script>

